
// 日期維度常量
const DATE_DIMENSION = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  PCCONSOLEDAY: 'pcConsoleDay'
};
const { DAY, WEEK, MONTH } = DATE_DIMENSION;

export const PAGE_ID = 'overview';
export const PAGE_ID_WEEK = `${PAGE_ID  }_week`;
export const PAGE_ID_MONTH = `${PAGE_ID  }_month`;

// 页面id
export const PAGE_ID_CONFIG = {
  [DAY]: PAGE_ID,
  [WEEK]: PAGE_ID_WEEK,
  [MONTH]: PAGE_ID_MONTH
};

// Engagement Metrics Trends Day
const ENGAGEMENT_METRICS_TRENDS = [
  { text: 'DAU', value: 'dau' },
  { text: 'New', value: 'new' },
  { text: 'D2/3/7', value: 'd237' },
  { text: 'TNU', value: 'tru' },
  { text: 'PCU', value: 'pcu' },
  { text: 'Avg.playtime(min)', value: 'aot' },
];

// Engagement Metrics Trends Week
const ENGAGEMENT_METRICS_TRENDS_WEEK = [
  { text: 'WAU', value: 'wau' },
  { text: 'New', value: 'new' },
  { text: 'W2/3', value: 'w23' },
  { text: 'TNU', value: 'tru' },
  { text: 'PCU', value: 'pcu' },
  { text: 'Avg.playtime(min)', value: 'aot' },
];

// Engagement Metrics Trends Month
const ENGAGEMENT_METRICS_TRENDS_MONTH = [
  { text: 'MAU', value: 'mau' },
  { text: 'New', value: 'new' },
  { text: 'M2/3', value: 'm23' },
  { text: 'TNU', value: 'tru' },
  { text: 'PCU', value: 'pcu' },
  { text: 'Avg.playtime(min)', value: 'aot' },
];

// 日周月 字母配置
const METRICS_CONFIG = {
  [DAY]: 'd',
  [WEEK]: 'w',
  [MONTH]: 'm',
};

// Engagement Metrics Trends Tab List
const ENGAGEMENT_METRICS_TRENDS_TAB_LIST = {
  [DAY]: ENGAGEMENT_METRICS_TRENDS,
  [WEEK]: ENGAGEMENT_METRICS_TRENDS_WEEK,
  [MONTH]: ENGAGEMENT_METRICS_TRENDS_MONTH
};

// Revenue Metrics Trends
const REVENUE_METRICS_TRENDS = [
  { text: 'Revenue($)', value: 'revenue' /* unit: '$' */ },
  { text: 'ARPPU($)', value: 'arppu' },
  { text: 'ARPU($)', value: 'arpu' },
  { text: 'Payer', value: 'payer' },
  { text: 'Payer%', value: 'payer_ratio' },
];

// Countries / Area Breakdown
const COUNTRY_AREA_ZONE = [
  { text: 'Country', value: 'country' },
  { text: 'Region', value: 'region' },
  { text: 'Zone', value: 'zone' },
];

const COUNTRY_AREA_ZONE_DOWNLOADS = {
  country: {
    DAU: {
      countryName: 'Country',
      countryValueName: 'Average DAU',
      share: 'Share of ALL',
      date: 'DATE'
    },
    Revenue: {
      countryName: 'Country',
      countryValueName: 'Sum Revenue',
      share: 'Share of ALL',
      date: 'DATE'
    },
    NEW: {
      countryName: 'Country',
      countryValueName: 'Sum New',
      share: 'Share of ALL',
      date: 'DATE'
    }
  },
  region: {
    DAU: {
      countryName: 'Region',
      countryValueName: 'Average DAU',
      share: 'Share of ALL',
      date: 'DATE'
    },
    Revenue: {
      countryName: 'Region',
      countryValueName: 'Sum Revenue',
      share: 'Share of ALL',
      date: 'DATE'
    },
    NEW: {
      countryName: 'Region',
      countryValueName: 'Sum New',
      share: 'Share of ALL',
      date: 'DATE'
    }
  },
  zone: {
    DAU: {
      countryName: 'Zone',
      countryValueName: 'Average DAU',
      share: 'Share of ALL',
      date: 'DATE'
    },
    Revenue: {
      countryName: 'Zone',
      countryValueName: 'Sum Revenue',
      share: 'Share of ALL',
      date: 'DATE'
    },
    NEW: {
      countryName: 'Zone',
      countryValueName: 'Sum New',
      share: 'Share of ALL',
      date: 'DATE'
    }
  }
};


const CHART_TYPE = {
  COLUMN: 'column',
  LINE: 'line',
  TABLE: 'table',
};

const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  LANGUAGE: 'language',
  CHANNEL: 'channel',
  IS_INIT: 'isInit'
};
const TABLE_TAG = {
  NEW: 'new',
  ACTIVE: 'active'
};

const RESET = 'reset';
const CONTROL = 'control';

const FORM_KEYS = ['rangeTime', 'zone', 'region', 'system', 'channel'];

const SYSTEM_LIST = [
  {
    text: 'Android',
    value: '1',
  },
  {
    text: 'IOS',
    value: '2',
  },
  {
    text: 'Web',
    value: '3',
  },
  {
    text: 'Linux',
    value: '4',
  },
  {
    text: 'Windows',
    value: '5',
  },
  {
    text: 'Nintendo',
    value: '6',
  },
  {
    text: 'Mac',
    value: '7',
  },
  {
    text: 'Playstation',
    value: '8',
  },
  {
    text: 'XBox',
    value: '9',
  },
];

const METRICS_LEGEND_MAP = {
  LAST_DATE: {
    key: 'last_week',
    name: 'Last Week',
  },
  THIS_DATE: {
    key: 'to_date',
    name: 'Today',
  },
};

const METRICS_LEGEND_MAP_WEEK = {
  LAST_DATE: {
    key: 'last_month',
    name: 'Last Month',
  },
  THIS_DATE: {
    key: 'to_week',
    name: 'This Week',
  },
};

const METRICS_LEGEND_MAP_MONTH = {
  LAST_DATE: {
    key: 'last_year',
    name: 'Last Year',
  },
  THIS_DATE: {
    key: 'this_year',
    name: 'This Month',
  },
};

const LINE_METRICS_LEGEND_MAP = {
  [DAY]: METRICS_LEGEND_MAP,
  [WEEK]: METRICS_LEGEND_MAP_WEEK,
  [MONTH]: METRICS_LEGEND_MAP_MONTH
};

const METRICS_COLORS = ['#5086F3', '#77E097', '#6A7597', '#F8CC6A', '#A08FF2', '#5EC8F1', '#CF61AC', '#F19E55', '#387F7D', '#F17C86', '#8EB9FF'];


/**
 * 指标的全称解释与变化幅度统计逻辑
 */
const INDICATOR_MEANING = ['DAU', 'Revenue', 'New', 'D2(T-1)', 'ARPU', 'Payer%'];

/**
 * 根据接口metrics_name枚举
 * 替换title展示
 * 主数据显示单位font(前)、end(后)、type*(浮窗数据是否加% 枚举:int percent)
 */
const CARD_TYPE = {
  [INDICATOR_MEANING[0]]: {
    title: 'DAU',
    font: '',
    end: '',
    type: 'int',
  },
  [INDICATOR_MEANING[1]]: {
    title: 'Revenue',
    font: '',
    end: '',
    type: 'int',
    //  unit: '$'
  },
  [INDICATOR_MEANING[2]]: {
    title: 'New',
    font: '',
    end: '',
    type: 'int',
  },
  [INDICATOR_MEANING[3]]: {
    title: 'D2(T-1)',
    font: '',
    end: '',
    type: 'percent',
  },
  [INDICATOR_MEANING[4]]: {
    title: 'ARPU',
    font: '',
    end: '',
    type: 'int',
  },
  'PayerRatio%': {
    title: 'Payer%',
    font: '',
    end: '%',
    type: 'int',
  },
  [INDICATOR_MEANING[5]]: {
    title: 'Payer%',
    font: '',
    end: '%',
    type: 'percent',
  },
};

/**
 * 需求添加($)的指标
 */
const DOLLAR_METRICS = ['Revenue', 'ARPU', 'ARPPU', 'new users ARPPU'];

// 分解图指标常量
const BREAKDOWN_METRICS = {
  DAY: {
    AU: 'DAU',
    BREAKDOWN_AND_NEWUSERS_TITLE: ['DAU Breakdown', 'Channels of New Users'],
    BREAKDOWN_TOTAL: 'dau_breakdown_total',
    BREAKDOWN: 'dau_breakdown',
  },
  WEEK: {
    AU: 'WAU',
    BREAKDOWN_AND_NEWUSERS_TITLE: ['WAU Breakdown', 'Channels of New Users'],
    BREAKDOWN_TOTAL: 'wau_breakdown_total',
    BREAKDOWN: 'wau_breakdown',
  },
  MONTH: {
    AU: 'MAU',
    BREAKDOWN_AND_NEWUSERS_TITLE: ['MAU Breakdown', 'Channels of New Users'],
    BREAKDOWN_TOTAL: 'mau_breakdown_total',
    BREAKDOWN: 'mau_breakdown',
  },
};
/**
 * 根据接口metrics_name枚举
 * 替换title展示
 * 主数据显示单位font(前)、end(后)、type*(浮窗数据是否加% 枚举:int percent)
 */
const METRICS_INFO = {
  Revenue: {
    title: 'Revenue',
    font: '',
    end: '($)',
    type: 'int',
    decimal: 2,
  },
  New: {
    title: 'New',
    font: '',
    end: '',
    type: 'int'
  },
  ARPU: {
    title: 'ARPU',
    font: '',
    end: '($)',
    type: 'int',
    decimal: 2,
  },
  'PayerRatio%': {
    title: 'Payer%',
    font: '',
    end: '%',
    type: 'int'
  },
  'Payer%': {
    title: 'Payer%',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
  DAU: {
    title: 'DAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  'D2(T-1)': {
    title: 'D2(T-1)',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
  WAU: {
    title: 'WAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  'W2(T-1)': {
    title: 'W2(T-1)',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
  MAU: {
    title: 'MAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  'M2(T-1)': {
    title: 'M2(T-1)',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },


};
const METRICS_NAME_DAY = ['DAU', 'Revenue', 'New', 'D2(T-1)', 'ARPU', 'Payer%'];
const METRICS_NAME_WEEK = ['WAU', 'Revenue', 'New', 'W2(T-1)', 'ARPU', 'Payer%'];
const METRICS_NAME_MONTH = ['MAU', 'Revenue', 'New', 'M2(T-1)', 'ARPU', 'Payer%'];

const MOMENT_DATE_ID = {
  [DATE_DIMENSION.DAY]: 'days',
  [DATE_DIMENSION.WEEK]: 'weeks',
  [DATE_DIMENSION.MONTH]: 'months',
  [DATE_DIMENSION.PCCONSOLEDAY]: 'pcConsoleDay'

};

// 单位阈值常数 Constants for unit thresholds
export const THOUSAND_THRESHOLD = 1000;
export const MILLION_THRESHOLD = THOUSAND_THRESHOLD * 1000;
export const BILLION_THRESHOLD = MILLION_THRESHOLD * 1000;

export {
  ENGAGEMENT_METRICS_TRENDS,
  METRICS_CONFIG,
  ENGAGEMENT_METRICS_TRENDS_TAB_LIST,
  COUNTRY_AREA_ZONE_DOWNLOADS,
  REVENUE_METRICS_TRENDS,
  COUNTRY_AREA_ZONE,
  CHART_TYPE,
  FORM_MAP,
  RESET,
  CONTROL,
  FORM_KEYS,
  SYSTEM_LIST,
  METRICS_LEGEND_MAP,
  LINE_METRICS_LEGEND_MAP,
  METRICS_COLORS,
  INDICATOR_MEANING,
  CARD_TYPE,
  DOLLAR_METRICS,
  METRICS_INFO,
  METRICS_NAME_DAY,
  METRICS_NAME_WEEK,
  METRICS_NAME_MONTH,
  DATE_DIMENSION,
  BREAKDOWN_METRICS,
  MOMENT_DATE_ID,
  TABLE_TAG,
};

export const OFFICIAL_WEBSITE = [
  "official website", 
  "officialwebsite", 
  "官网", 
  "官网(非mac)", 
  "官网(mac)", 
  "official website(mac)"];

export const ARPU_TYPES = [
  "arpu",
  "new_user_arpu"
];
